module.exports = __webpack_public_path__ + "prod/1.42.2/img/wudian-wu.52021cb5.png";